"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var __1 = require("..");

function noop() {
  return;
}

var formWrapper = function (_super) {
  __extends(formWrapper, _super);

  function formWrapper(props) {
    var _this = _super.call(this, props) || this;

    var formWrapperId = props.formWrapperId,
        id = props.id;
    var wrapperId = formWrapperId || "form-" + id + "-" + new Date().getTime();
    _this.state = {
      loading: true,
      wrapperId: wrapperId
    };
    return _this;
  }

  formWrapper.prototype.componentDidMount = function () {
    var _this = this;

    var _a = this.props,
        id = _a.id,
        marketCode = _a.marketCode,
        _b = _a.plugins,
        plugins = _b === void 0 ? {} : _b,
        _c = _a.formConfigurationEndpoint,
        formConfigurationEndpoint = _c === void 0 ? '' : _c,
        _d = _a.onPreConfigurationDownloaded,
        onPreConfigurationDownloaded = _d === void 0 ? noop : _d,
        _e = _a.onConfigurationDownloaded,
        onConfigurationDownloaded = _e === void 0 ? noop : _e,
        _f = _a.onPostConfigurationDownloaded,
        onPostConfigurationDownloaded = _f === void 0 ? noop : _f,
        _g = _a.onPreFormRendered,
        onPreFormRendered = _g === void 0 ? noop : _g,
        _h = _a.onFormRendered,
        onFormRendered = _h === void 0 ? noop : _h,
        _j = _a.onPostFormRendered,
        onPostFormRendered = _j === void 0 ? noop : _j,
        _k = _a.onPreFormView,
        onPreFormView = _k === void 0 ? noop : _k,
        _l = _a.onFormView,
        onFormView = _l === void 0 ? noop : _l,
        _m = _a.onPostFormView,
        onPostFormView = _m === void 0 ? noop : _m,
        _o = _a.onPreValidationFailed,
        onPreValidationFailed = _o === void 0 ? noop : _o,
        _p = _a.onValidationFailed,
        onValidationFailed = _p === void 0 ? noop : _p,
        _q = _a.onPostValidationFailed,
        onPostValidationFailed = _q === void 0 ? noop : _q,
        _r = _a.onPreSubmissionObjectReady,
        onPreSubmissionObjectReady = _r === void 0 ? noop : _r,
        _s = _a.onSubmissionObjectReady,
        onSubmissionObjectReady = _s === void 0 ? noop : _s,
        _t = _a.onPostSubmissionObjectReady,
        onPostSubmissionObjectReady = _t === void 0 ? noop : _t,
        _u = _a.onPreSubmissionCompleted,
        onPreSubmissionCompleted = _u === void 0 ? noop : _u,
        _v = _a.onSubmissionCompleted,
        onSubmissionCompleted = _v === void 0 ? noop : _v,
        _w = _a.onPostSubmissionCompleted,
        onPostSubmissionCompleted = _w === void 0 ? noop : _w,
        _x = _a.onPreSubmissionFailed,
        onPreSubmissionFailed = _x === void 0 ? noop : _x,
        _y = _a.onSubmissionFailed,
        onSubmissionFailed = _y === void 0 ? noop : _y,
        _z = _a.onPostSubmissionFailed,
        onPostSubmissionFailed = _z === void 0 ? noop : _z,
        _0 = _a.formWrapperCSSClass,
        formWrapperCSSClass = _0 === void 0 ? '' : _0,
        _1 = _a.applyGud,
        applyGud = _1 === void 0 ? false : _1,
        _2 = _a.labelAsPlaceholder,
        labelAsPlaceholder = _2 === void 0 ? '' : _2;
    var _3 = this.state,
        loading = _3.loading,
        wrapperId = _3.wrapperId;
    var wrapperElement = document.getElementById(wrapperId);
    var alreadyExistingForm = wrapperElement === null || wrapperElement === void 0 ? void 0 : wrapperElement.querySelector('form');

    if (!alreadyExistingForm && loading) {
      new __1.Form({
        id: id,
        marketCode: marketCode,
        container: "#" + wrapperId,
        plugins: plugins,
        formConfigurationEndpoint: formConfigurationEndpoint,
        formWrapperCSSClass: formWrapperCSSClass,
        applyGud: applyGud,
        labelAsPlaceholder: labelAsPlaceholder
      }).on('preconfigurationDownloaded', 'preconfigurationDownloaded', function (form) {
        return onPreConfigurationDownloaded(form);
      }).on('configurationDownloaded', 'configurationDownloaded', function (form) {
        return onConfigurationDownloaded(form);
      }).on('postconfigurationDownloaded', 'postconfigurationDownloaded', function (form) {
        return onPostConfigurationDownloaded(form);
      }).on('preformRendered', 'preformRendered', function (form) {
        return onPreFormRendered(form);
      }).on('formRendered', 'formRendered', function (form) {
        _this.setState({
          loading: false
        });

        return onFormRendered(form);
      }).on('postformRendered', 'postformRendered', function (form) {
        return onPostFormRendered(form);
      }).on('preformView', 'forpreformViewmView', function (form) {
        return onPreFormView(form);
      }).on('formView', 'formView', function (form) {
        return onFormView(form);
      }).on('postformView', 'postformView', function (form) {
        return onPostFormView(form);
      }).on('prevalidationFailed', 'prevalidationFailed', function (form) {
        return onPreValidationFailed(form);
      }).on('validationFailed', 'validationFailed', function (form) {
        return onValidationFailed(form);
      }).on('postvalidationFailed', 'postvalidationFailed', function (form) {
        return onPostValidationFailed(form);
      }).on('presubmissionObjectReady', 'presubmissionObjectReady', function (form) {
        return onPreSubmissionObjectReady(form);
      }).on('submissionObjectReady', 'submissionObjectReady', function (form) {
        return onSubmissionObjectReady(form);
      }).on('postsubmissionObjectReady', 'postsubmissionObjectReady', function (form) {
        return onPostSubmissionObjectReady(form);
      }).on('presubmissionCompleted', 'presubmissionCompleted', function (form) {
        return onPreSubmissionCompleted(form);
      }).on('submissionCompleted', 'submissionCompleted', function (form) {
        return onSubmissionCompleted(form);
      }).on('postsubmissionCompleted', 'postsubmissionCompleted', function (form) {
        return onPostSubmissionCompleted(form);
      }).on('presubmissionFailed', 'presubmissionFailed', function (form) {
        return onPreSubmissionFailed(form);
      }).on('submissionFailed', 'submissionFailed', function (form) {
        return onSubmissionFailed(form);
      }).on('postsubmissionFailed', 'postsubmissionFailed', function (form) {
        return onPostSubmissionFailed(form);
      }).render();
    }
  };

  formWrapper.prototype.render = function () {
    var _a = this.state,
        loading = _a.loading,
        wrapperId = _a.wrapperId;
    var className = this.props.className;
    return react_1.default.createElement("div", {
      id: wrapperId,
      className: className + " " + (loading ? 'ef-form-loading' : 'ef-form-loaded')
    });
  };

  return formWrapper;
}(react_1.Component);

exports.default = formWrapper;